import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext'; // Asegúrate de tener el contexto de usuario implementado correctamente
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';

function AddEquipo({ onNewEquipo, editingEquipo }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [descripcion, setDescripcion] = useState('');
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    const [modificacion, setModificacion] = useState(1);
    const [IngresadoPor, setIngresadoPor] = useState('');

    // Función para obtener la fecha actual en formato ISO sin la 'Z' final
    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        const fechaISO = fecha.toISOString().slice(0, -1);
        return fechaISO;
    }
    const fechaFormateada = obtenerFechaISOsinZ();

    useEffect(() => {
        if (editingEquipo) {
            setDescripcion(editingEquipo.descripcion);
            setModificacion(2);
            setIngresadoPor(editingEquipo.ingresadoPor);

        } else {
            setModificacion(1);
            setIngresadoPor('');

        }
    }, [editingEquipo]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const equipo = {
            id: editingEquipo ? editingEquipo.id : 0,
            descripcion,
            IngresadoPor: !editingEquipo ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
            ModificadoPor: editingEquipo ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
         
        };
        Object.keys(equipo).forEach(key => equipo[key] === undefined && delete equipo[key]);

        const method = editingEquipo ? 'PUT' : 'POST';
        const endpoint = editingEquipo ? `${server}/MgEquipoes/${editingEquipo.id}` : `${server}/MgEquipoes`;

        try {
            const response = await fetch(endpoint, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(equipo),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });
                setDescripcion('');
                onNewEquipo(); // Actualizar la lista de equipos
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
          
            Swal.fire({
                icon: 'error',
                title: 'Error al guardar el equipo',
                text: error || 'Ocurrió un error inesperado',
            });
        }
    };

    return (
        <>
            <h2>{editingEquipo ? "Editar Equipo" : "Agregar Equipo"}</h2>
            <br />
            <form className="form-horizontal form-label-left" onSubmit={handleSubmit}>
               
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcion">Descripción:</label>
                    <div className="col-md-3 col-sm-6">
                        <input
                            type="text"
                            id="descripcion"
                            className="form-control"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                    </div>
                </div>
                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Equipo')}>Guardar</button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AddEquipo;
